import type { AllocationChangedEventData, BillChangedEventData, IdentityChangedEventData } from "@/data/events/events";
import type { IUserItemSelection } from "@/data/model/Bill";
import type { ICustomerCart } from "@/data/model/Customer";
import type { ShowRoomPlanEventData } from "@/data/model/Table";
import { Signal, TypedSignal } from "@/data/util/Signal";


export type CartUpdatedEventData = {
    cart: ICustomerCart;
    updateHash: string;
};

export const appEvents = {
    // app context events
    appContext: {
        OrderChanged: new TypedSignal<string>(),
        ItemSelectionChanged: new TypedSignal<Array<IUserItemSelection>>(),
        AllocationChanged: new TypedSignal<AllocationChangedEventData>(),
        BillChanged: new TypedSignal<BillChangedEventData>(),
        GuestNumberChanged: new TypedSignal<string>(),
        OfferChanged: new Signal(),
        SelectedServiceChanged: new Signal(),
        OfferLoadingStarted: new Signal(),
    },
    views: {
        ShowRoomPlan: new TypedSignal<ShowRoomPlanEventData>(),
    },
    payContext: {
        totalDiscountMismatchPopupViewed: new Signal(),
    },
    controller: {
        hidden: new Signal(),
        shown: new TypedSignal<string>(),
    },
    kiosk: {
        inactivityPopupShown: new Signal(),
    },
    identity: {
        identityChanged: new TypedSignal<IdentityChangedEventData>(),
    },
    tastierClient: {
        initialized: new Signal(),
    },
    cartController: {
        cartUpdated: new TypedSignal<CartUpdatedEventData>(),
    },
};
